module.exports = __webpack_public_path__ + "media/images/icon-dropdown-arrow-00bb6749d36deecef30ac30cbad2ffad.svg";